import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled, { withTheme } from 'styled-components';
import { Divider, Affix, message, Upload, Modal } from 'antd'
import moment from 'moment'
import { saveAs } from 'file-saver'
import { Flex, FlexColumn, CardContainer, LightContainer } from '../../Reusable/Container'
import PageHeader from '../../Reusable/PageHeader'
import { Text, Tag } from '../../Reusable/Text'
import { LabeledInput, ErrorLabel } from '../../Reusable/Input'
import { Button, ImageButton, TextButton } from '../../Reusable/Button'
import AionLogo, { Image } from '../../Reusable/Image'
import AlertModal from '../../Reusable/AlertModal'
import { ErrorAlert } from '../../Reusable/Alert'
import BusinessPreviewCard from './BusinessPreviewCard';

import { Editor, EditorState } from 'draft-js'
import 'draft-js/dist/Draft.css'
import { stateFromHTML } from 'draft-js-import-html'
import { stateToHTML } from 'draft-js-export-html'
import renderHTML from 'react-render-html'
import { LoadingOutlined } from '@ant-design/icons';

import { copyToClipboard, getDateInLocalTZ } from '../../../Utils/util'
import { apiPOSTReq, apiGETDocUrl } from '../../../Utils/api'
import environment from '../../../environment'

import Refresh from '../../../Images/refresh.svg'
import PayerMsg from '../../../Images/payer-message-sent.svg'
import PayerUpload from '../../../Images/payer-upload.svg'
import ModalClose from '../../../Images/promo-close.svg'
import AionLogoImg from "../../../Images/aion.svg"
import UploadIcon from '../../../Images/upload-dark.svg'
import Asterisk from '../../../Images/asterisk.png'
import Link from '../../../Images/auto-debit-link.svg'
import Payment from '../../../Images/auto-debit-payment.svg'
import Verified from '../../../Images/auto-debit-verified.svg'
import Bulb from '../../../Images/light-bulb.svg'


const { Dragger } = Upload

export const StyledDragger = styled(Dragger)`
    .ant-upload.ant-upload-drag {
        background: #F8F8F9 !important;
        border: 1px dashed #7384AA !important;
        border-radius: 8px !important;
        max-width: 370px;
    }
`;

export const FloatingCenteredBox = styled.div`
  display: flex;
  padding: 12px;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  border-radius: var(--Radius-R16, 16px);
  background: var(--Background-Grey, #F7F7F9);

  /* Elevation/Float */
  box-shadow: 0px 0px 64px 0px rgba(172, 172, 172, 0.24);
  min-height: 780px;
  gap: 48px;
`;

export const PaymentMethodPreview = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;

  width: 390px;
  height: 100%;
  padding: var(--Spacing-S16, 16px);
  border-radius: var(--Radius-R8, 8px);
  background: var(--Background-White, #FFF);
`;

export const GradientBox = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  border-radius: var(--Radius-R8, 8px);
  background: linear-gradient(
      105deg,
      #F7F7F9 39.85%,
      var(--Near-Black-Near-Black---0, #E6E6EC) 97.2%
    ),
    linear-gradient(
      239deg,
      #F7F7F9 25.62%,
      var(--Near-Black-Near-Black---0, #E6E6EC) 95.24%
    );
`;

export const Placeholder = styled.div`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '40px'};
  border-radius: ${({ radius }) => radius || '8px'};
  background: ${({ background }) => background || 'var(--Grey-Grey---0, #F7F7F9)'};
`;

class SendPaymentNotification extends Component {

    constructor(props) {
        super(props)

        const { aionStore } = props
        var { business } = aionStore
        var { businessInfo } = business.businessProfile || {}
        businessInfo = businessInfo || {}
        const imageUrl = businessInfo.logoUrl

        this.state = {
            customers: this.props.location?.state?.customers,
            // subject: `${businessInfo?.name} is requesting you to set up your billing details`,
            step: "customize",
            toEmail: this.props.location?.state?.customers[0]?.ToAddr,
            feeLabel: "Activation Fee",
        }
    }

    componentDidMount() {
        // this.preview()
        this.fetchBusinessData()
        this.autoPopulateFields()

        var { businessName } = this.props.aionStore
        this.setState({ fromName: businessName })
    }

    autoPopulateFields = () => {
        const { aionStore } = this.props
        const { customers } = this.state

        var { business } = aionStore
        var { businessInfo } = business.businessProfile || {}
        businessInfo = businessInfo || {}

        var body = {
            CustomerId: customers[0]?.CustomerId,
        }

        console.log("SendPaymentNotification autoPopulateFields body", body)

        apiPOSTReq(`${environment.iveBaseUrl}/ive/bc/autoPopulateFields`, null, body, (err, resp) => {
            try {
                const data = resp || {};
                console.log("SendPaymentNotification autoPopulateFields data", data)
                if (data.result) {
                    this.setState({
                        businessName: data?.businessName || businessInfo?.name,
                        description: data?.description,
                        phone: data?.businessPhone,
                        email: data?.businessEmail,
                        feeLabel: data?.feeLabel || "Activation Fee",
                        contactName: data?.businessContactName,
                        subject: `${businessInfo?.name} is requesting you to set up your billing details`,
                        logoUrl: data?.logoUrl,
                    })
                } else {
                    throw Error(data.error || data.responseMessage || "Could not fetch payers")
                }
            } catch (error) {
                console.log("SendPaymentNotification autoPopulateFields error", error)
                // ErrorAlert({ description: error.message || "Sorry, we had trouble fetching your invite. Please try again." })
            } finally {
                this.setState({ getStartedLoading: false, loading: false })
            }
        })
    }

    preview = () => {
        const { aionStore } = this.props
        const { customers, logoUrl, businessName, emailRefNumber } = this.state
        this.setState({ loadingPreviewEmail: true })

        var { business } = aionStore
        var { businessInfo } = business.businessProfile || {}
        businessInfo = businessInfo || {}
        const imageUrl = businessInfo.logoUrl

        var body = {
            CustomerId: customers[0]?.CustomerId,
            ToAddr: customers[0]?.ToAddr,
            LogoUrl: logoUrl || imageUrl,
            businessName: businessName || businessInfo?.name,
            ReferenceNum: emailRefNumber,
        }

        console.log("SendPaymentNotification previewPaymentMethodCollectionEmail body: ", body)

        // this.setState({ nextLoading: true, subject: `${businessName || businessInfo?.name} is requesting you to set up your billing details` })

        apiPOSTReq(`${environment.iveBaseUrl}/ive/bc/previewPaymentMethodCollectionEmail`, null, body, (err, resp) => {
            try {
                const data = resp || {};

                console.log("SendPaymentNotification previewPaymentMethodCollectionEmail: ", data)
                if (data.result) {
                    this.setState({
                        mainHTML: data.htmlMailText,
                        step: "share",
                        // customHTMLBody: data.invoiceEmailCustomBody,
                        // previewPaymentConfirmationEmail: true,
                        // loadingPreviewEmail: false,
                        // editorState: EditorState.createWithContent(stateFromHTML(data.invoiceEmailCustomBody))
                    })
                } else {
                    throw Error(data.error || data.responseMessage || "Could not fetch payers")
                }
            } catch (error) {
                console.log("ERRR previewPaymentMethodCollectionEmail", error, err, resp)
            } finally {
                this.setState({ nextLoading: false })
            }
        })
    }

    downloadAccountVerificationPDF = (accountId) => {
        this.setState({ loadingAccountVerificationPDF: true })
        var query = {
            AccountId: accountId
        }
        apiGETDocUrl(`${environment.bbBaseUrl}/bb/export/pdf/accountVerificationTemplate`, {}, query, (err, resp) => {
            this.setState({ loadingAccountVerificationPDF: false })
            const data = (resp || {}).data
            try {
                if (err) throw Error("We had trouble downloading your account verification. Please try again.")
                const blob = new Blob([data], {
                    type: 'application/pdf',
                })
                const fileURL = URL.createObjectURL(blob)
                saveAs(fileURL, `Bank Account Letter ${moment().format('MMDDYY')}`)
            } catch (error) {
                ErrorAlert({ description: error.message })
            }
        })
    }

    fetchBusinessData = (options) => {
        const { aionStore } = this.props;
        var body = {
            "clientBusinessId": aionStore.BusinessUniqueKey
        };
        console.log("/ive/invoice/getBusinessData body", body);
        this.setState({ loading: true });
        apiPOSTReq(`${environment.iveBaseUrl}/ive/invoice/getBusinessData`, null, body, (err, resp) => {
            this.setState({ loading: false });
            try {
                const data = resp || {};
                console.log("/ive/invoice/getBusinessData data", data);
                if (data.result) {
                    const arcommunicationInfo = ((data.business || {}).businessProfile || {}).arcommunicationInfo
                    const bbAccounts = ((data.business || {}).businessBanking || {}).accounts
                    if (arcommunicationInfo && arcommunicationInfo.cc) {
                        var ccEmails = [arcommunicationInfo.cc]
                        this.setState({ ccEmails })
                    }

                    if (bbAccounts) {
                        const arAccount = bbAccounts.find(account => (account.accountType == 'ACCOUNTS_RECEIVABLE'));
                        this.setState({ arAccount: arAccount })
                    }
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                //console.log("/getPersonCards err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." });
            }
        });
    }

    send = () => {
        const { aionStore } = this.props
        var { fromName, subject, customers, feeLabel, logoUrl, businessName, description, contactName, phone, toEmail, email, emailRefNumber, ccEmail } = this.state;

        this.setState({ loadingSendEmail: true })

        var { business } = aionStore
        var { businessInfo } = business.businessProfile || {}
        businessInfo = businessInfo || {}
        const imageUrl = businessInfo.logoUrl

        var body = {
            FromName: fromName,
            Subject: subject,
            PaymentMethodCollectionRequests: [{
                CustomerId: customers[0]?.CustomerId,
                ToAddr: toEmail,
                CCAddr: ccEmail,
                LogoUrl: logoUrl || imageUrl,
            }],
            feeLabel,
            LogoUrl: logoUrl || imageUrl,
            businessName,
            description,
            BusinessContactName: contactName,
            BusinessPhone: phone,
            BusinessEmail: email,
            ReferenceNum: emailRefNumber,
        }

        console.log("sendAutoDebitPMCollectionEmail: ", body)
        apiPOSTReq(`${environment.iveBaseUrl}/ive/bc/sendAutoDebitPMCollectionEmail`, null, body, (err, resp) => {
            try {
                const data = resp || {}
                console.log("/sendAutoDebitPMCollectionEmail", data)
                if (data.result) {
                    // message.success(`Payment instructions sent!`)
                    this.setState({ showSentModal: true })
                } else {
                    message.error(`Error sending payment instructions!`)
                    throw Error(data.error || data.responseMessage || "Could not send payment confirmation email")
                }
            } catch (error) {
                console.log("ERRR sendAutoDebitPMCollectionEmail", error, err, resp)
                ErrorAlert({ description: error.message })
            } finally {
                this.setState({ loadingSendEmail: false })
            }
        })
    }

    generatePMCollectionLink = () => {
        const { aionStore } = this.props
        var { fromName, subject, customers, feeLabel, logoUrl, businessName, description, contactName, phone, toEmail, email, emailRefNumber, ccEmail } = this.state;

        this.setState({ loadingGenLink: true })

        var { business } = aionStore
        var { businessInfo } = business.businessProfile || {}
        businessInfo = businessInfo || {}
        const imageUrl = businessInfo.logoUrl

        var body = {
            CustomerId: customers[0]?.CustomerId,
            feeLabel,
            LogoUrl: logoUrl || imageUrl,
            FromName: fromName,
            Subject: subject,
            PaymentMethodCollectionRequests: [{
                CustomerId: customers[0]?.CustomerId,
                ToAddr: toEmail,
                CCAddr: ccEmail,
                LogoUrl: logoUrl || imageUrl,
            }],
            businessName,
            description,
            BusinessContactName: contactName,
            BusinessPhone: phone,
            BusinessEmail: email,
            ReferenceNum: emailRefNumber,
        }

        console.log("generatePMCollectionLink body: ", body)
        apiPOSTReq(`${environment.iveBaseUrl}/ive/bc/generatePMCollectionLink`, null, body, (err, resp) => {
            try {
                const data = resp || {}
                console.log("/generatePMCollectionLink resp", data)
                if (data.result) {
                    // this.setState({ showSentModal: true })

                    // this.setState({ step: "share" })

                    this.setState({
                        step: "link-created",
                        inviteLink: data?.inviteLink,
                        inviteInfo: data?.inviteInfo,
                        emailRefNumber: data?.inviteInfo?.emailRefNumber,
                        emailExpiry: data?.inviteInfo?.emailExpiry,
                    })
                } else {
                    throw Error(data.error || data.responseMessage || "Could not send payment confirmation email")
                }
            } catch (error) {
                console.log("ERRR generatePMCollectionLink", error, err, resp)
                ErrorAlert({ description: error.message })
            } finally {
                this.setState({ loadingGenLink: false })
            }
        })
    }

    next = () => {
        const { contactName, email, phone, feeLabel, businessName, description } = this.state

        if (!businessName) {
            this.setState({ errorField: "businessName", errorMessage: "Business name is a required field." })
            return
        }
        if (!description) {
            this.setState({ errorField: "description", errorMessage: "Description is a required field." })
            return
        }
        if (!feeLabel) {
            this.setState({ errorField: "feeLabel", errorMessage: "Fee label is a required field." })
            return
        }
        if (!contactName) {
            this.setState({ errorField: "contactName", errorMessage: "Contact name is a required field." })
            return
        }
        if (!phone) {
            this.setState({ errorField: "phone", errorMessage: "Contact phone is a required field." })
            return
        }
        if (!email) {
            this.setState({ errorField: "email", errorMessage: "Contact email is a required field." })
            return
        }

        this.generatePMCollectionLink()
    }

    render() {
        const { theme, aionStore } = this.props
        const { subject, customers, errorField, showSentModal, loadingSendEmail, step, mainHTML, errorMessage, contactName, loadingGenLink, emailExpiry,
            email, phone, loading, error, logoUrl, feeLabel, showLearnMore, businessName, description, toEmail, ccEmail, nextLoading, inviteLink } = this.state

        const uploadProps = {
            action: `${environment.apiBaseUrl}/file/upload`,
            headers: {
                businesskey: aionStore.BusinessUniqueKey,
                type: "logo",
                jwt: aionStore.jwt
            },
            onChange: (info) => {
                var { fileList } = info;
                fileList.forEach(file => {
                    const { status, response, name, url } = file;
                    console.log("fileList response", response);
                    if (status === "done") {
                        this.setState({ logoUrl: (response.UploadedUrls || [])[0] });
                    }
                });
            }
        };

        var { business } = aionStore
        var { businessInfo } = business.businessProfile || {}
        businessInfo = businessInfo || {}
        const imageUrl = businessInfo.logoUrl

        var imgStyle = { height: 48, width: 48, objectFit: "contain", borderRadius: "5px" }

        const ImageBox = styled.div`
            width: 48px;
            height: 48px;
            border-radius: 9.6px;
            background: url(${logoUrl || imageUrl}) lightgray 50% / cover no-repeat;
            box-shadow: 0px 0px 9.6px 0px rgba(102, 102, 102, 0.08);
            `;

        return (<FlexColumn
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                margin: 0,
                padding: 0,
                zIndex: 10001, // Ensure it appears on top
                transform: 'none', // Override any transformation
                // background: 'white',
            }}
            start
            fullWidth
            fullHeight>

            <Flex
                fullWidth
                end
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    padding: '24px 24px 0',
                    zIndex: 1000,
                }}
            >
                {/* <AionLogo logoHeight={30} margin="0" /> */}
                <ImageButton src={ModalClose} onClick={() => window.history.back()} />
            </Flex>

            {(() => {
                switch (step) {
                    case "customize":
                        return <Flex fullWidth between fullHeight>

                            <BusinessPreviewCard
                                businessName={businessName}
                                description={description}
                                feeLabel={feeLabel}
                                contactName={contactName}
                                phone={phone}
                                email={email}
                                theme={theme}
                                logoUrl={logoUrl}
                            />

                            <FlexColumn start fullHeight style={{ marginBottom: 0, width: 790, background: 'white', paddingTop: 24 }} gap="24px">
                                <Flex between fullWidth style={{ padding: '0 24px' }}>
                                    <FlexColumn start>
                                        <Text size="24px" weight='600' heading>Customize billing link page</Text>
                                        <Text size="16px" color='#4F4F7B'>Update this page to suit your branding and invoicing needs</Text>
                                    </FlexColumn>

                                    {/* <ImageButton src={ModalClose} onClick={() => window.history.back()} /> */}
                                </Flex>

                                <FlexColumn start gap="24px" style={{ overflowY: 'auto', overflowX: 'hidden', padding: '0 24px' }}>
                                    <FlexColumn start gap="8px">
                                        <FlexColumn start>
                                            <Flex start bottom gap='4px'>
                                                <Text color={'#7384AA'} size='14px' margin='0 0 4px' weight={400}>Logo</Text>
                                                <Image width='5px' height='5px' margin='0 0 16px' src={Asterisk} />
                                            </Flex>
                                            <Flex start centerHorizontally gap="12px" fullWidth>
                                                {
                                                    (logoUrl || imageUrl) && <img src={logoUrl || imageUrl} style={imgStyle} />
                                                }

                                                {/* <Text size="16px" weight="500">{(businessInfo.name || "").trim()}</Text> */}
                                            </Flex>
                                        </FlexColumn>

                                        <FlexColumn start gap='4px' fullWidth>
                                            <Flex fullWidth>
                                                <StyledDragger {...uploadProps} showUploadList={false}>
                                                    <Flex start center style={{ width: 742, height: 54, maxWidth: 742 }} gap='16px'>
                                                        <Image src={UploadIcon} />
                                                        <FlexColumn start left gap='4px'>
                                                            <Text size='14px' weight='400' color='#4F4F7B'>{(logoUrl || imageUrl) ? 'Drag and drop here or click to upload a different logo' : 'Drag and drop here or click to upload.'}</Text>
                                                            <Text size="13px" weight='400' color='#4F4F7B'>{(logoUrl || imageUrl) ? 'Logos should be at least 600x600 pixels. We accept PNG & JPG' : 'Logos should be at least 600x600 pixels. We accept PNG & JPG'}</Text>
                                                        </FlexColumn>
                                                    </Flex>
                                                </StyledDragger>
                                            </Flex>
                                            {error && <ErrorLabel>Please upload a logo</ErrorLabel>}
                                        </FlexColumn>
                                    </FlexColumn>

                                    <LabeledInput
                                        inputRef={this.contactNameRef}
                                        nomargin
                                        label="Business name"
                                        id="businessName"
                                        key="businessName"
                                        // width="284px"
                                        placeholder="Tony Adams"
                                        // instruction="This business name will be used on any notifications sent to your customers"
                                        value={businessName}
                                        onChange={(event) => this.setState({ businessName: event.target.value })}
                                        error={errorField === "businessName"}
                                        errorMessage={errorMessage}
                                    />

                                    <LabeledInput
                                        inputRef={this.contactNameRef}
                                        nomargin
                                        label="Description"
                                        id="description"
                                        key="description"
                                        // width="284px"
                                        placeholder="Tony Adams"
                                        instruction={<Flex gap="4px" start centerH>
                                            <Image src={Bulb} />
                                            <Text color={theme.input.instrColor} size="12px">Tip: Keep this short and simple in line with your branding or website guidelines</Text>
                                        </Flex>}
                                        value={description}
                                        onChange={(event) => this.setState({ description: event.target.value })}
                                        error={errorField === "description"}
                                        errorMessage={errorMessage}
                                    />

                                    <LabeledInput
                                        label="Fee label"
                                        id="feeLabel"
                                        key="feeLabel"
                                        placeholder="E.g. Launch fee or Billing Setup Fee"
                                        value={feeLabel}
                                        onChange={(event) => this.setState({ feeLabel: event.target.value })}
                                        nomargin
                                        error={errorField === "feeLabel"}
                                        errorMessage={"Fee Label is a required field"}
                                    />

                                    <Text heading>Contact details</Text>

                                    <LabeledInput
                                        inputRef={this.contactNameRef}
                                        nomargin
                                        label="Contact Name"
                                        id="contactName"
                                        key="contactName"
                                        placeholder="Enter contact name"
                                        value={contactName}
                                        onChange={(event) => this.setState({ contactName: event.target.value })}
                                        error={errorField === "contactName"}
                                        errorMessage={errorMessage}
                                    />

                                    <Flex between fullWidth gap="24px">
                                        <LabeledInput
                                            inputRef={this.phoneRef}
                                            nomargin
                                            type="phone"
                                            label="Phone number"
                                            value={phone}
                                            maxLength={15}
                                            onChange={(event) => this.setState({ phone: event.target.value })}
                                            placeholder="Phone"
                                            error={errorField === "phone"}
                                            errorMessage={errorMessage}
                                        />

                                        <LabeledInput
                                            inputRef={this.emailRef}
                                            nomargin
                                            label="Contact email"
                                            type="email"
                                            id="email"
                                            key="email"
                                            // width="284px"
                                            value={email}
                                            onChange={(event) => this.setState({ email: event.target.value })}
                                            placeholder="Email"
                                            error={errorField === "email"}
                                            errorMessage={"Email is a required field"}
                                        />
                                    </Flex>

                                </FlexColumn>

                                <FlexColumn end grow>
                                    <Flex start centerHorizontally gap="24px" style={{ boxShadow: '0px -4px 8px -2px rgba(102, 102, 102, 0.08)', padding: '24px 24px' }}>
                                        <Button loading={loadingGenLink} text='Next' solid onClick={() => this.next()} />

                                        {/* <TextButton text="Learn more" underline weight='400' color='#8181A0' onClick={() => this.setState({ showLearnMore: true })} /> */}
                                    </Flex>
                                </FlexColumn>
                            </FlexColumn>
                        </Flex>
                    case "link-created":
                        return <Flex fullWidth between fullHeight>
                            <BusinessPreviewCard
                                businessName={businessName}
                                description={description}
                                feeLabel={feeLabel}
                                contactName={contactName}
                                phone={phone}
                                email={email}
                                theme={theme}
                                logoUrl={logoUrl}
                                onBack={() => this.setState({ step: "customize" })}
                            />

                            <FlexColumn start fullHeight style={{ marginBottom: 0, width: 790, minWidth: 790, background: 'white', paddingTop: 24 }} gap="24px">
                                <Flex between fullWidth style={{ padding: '0 24px' }}>
                                    <FlexColumn start>
                                        <Text size="24px" weight='600' heading>Billing link created</Text>
                                        <Text size="16px" color='#4F4F7B'>Copy and share externally or email link to your customer. This link expires in 7 days.</Text>
                                    </FlexColumn>
                                </Flex>

                                <FlexColumn left start gap="24px" style={{ overflowY: 'auto', overflowX: 'hidden', padding: '0 24px' }}>
                                    <FlexColumn start gap="24px">
                                        <FlexColumn start>
                                            {/* <Text color={'#7384AA'} size='14px' margin='0 0 4px' weight={400}>Shareable link</Text> */}
                                            <LightContainer padding="8px 12px">
                                                <Flex start centerH gap="24px">
                                                    <Text>{inviteLink}</Text>
                                                    {/* <ImageButton src={Copy} onClick={() => copyToClipboard(inviteLink)} /> */}

                                                    <Button size="12px" text="Copy link" height="24px" padding="4px 12px" onClick={() => copyToClipboard(inviteLink)} />
                                                </Flex>
                                            </LightContainer>
                                        </FlexColumn>

                                        <FlexColumn start>
                                            <Text color={'#7384AA'} size='14px' margin='0 0 4px' weight={400}>Valid until</Text>
                                            <Text size="16px">{moment(emailExpiry).format('MMM D, YYYY h:mm A')} ET</Text>
                                        </FlexColumn>
                                    </FlexColumn>

                                    <div style={{ height: 1, width: '100%', background: '#F7F7F9' }} />

                                    <FlexColumn start gap="8px">
                                        <Text heading>Email this link</Text>
                                        <Text>Email this link directly to your customer</Text>
                                    </FlexColumn>

                                    <Button loading={nextLoading} text="Send email invite" onClick={() => this.preview()} />
                                </FlexColumn>

                                <FlexColumn end grow>
                                    <Flex start centerHorizontally gap="24px" style={{ boxShadow: '0px -4px 8px -2px rgba(102, 102, 102, 0.08)', padding: '24px 24px' }}>
                                        <Button text='Done' solid onClick={() => window.history.back()} />
                                    </Flex>
                                </FlexColumn>
                            </FlexColumn>
                        </Flex>
                    case "share":
                        return <FlexColumn start center fullWidth style={{ margin: '48px 0' }} gap='24px'>
                            {/* <PageHeader
                                titleText={`Send Payment Update Email`}
                                marginBottom={24}
                                close
                                fullpage
                            /> */}

                            <FlexColumn start left>
                                <Text size="24px" weight='600' heading>Share billing link</Text>

                                <CardContainer style={{ marginTop: 24, width: 924, minWidth: 924, marginBottom: 48, minHeight: 900 }} center>
                                    <FlexColumn start>
                                        <Text heading weight='600' size="20px" margin='0 0 4px'>Preview and send email</Text>
                                        <Text>This email will be sent to the customer’s contact email. You can change it if needed.</Text>

                                        <Flex start centerHorizontally gap='8px' style={{ marginTop: 24 }}>
                                            <Text right caption weight='400' width="60px">To:</Text>

                                            <LabeledInput
                                                inputRef={this.subjectRef}
                                                nomargin
                                                small
                                                id="toEmail"
                                                key="toEmail"
                                                placeholder=""
                                                onChange={(event) => this.setState({ toEmail: event.target.value })}
                                                value={toEmail}
                                                error={errorField === "toEmail"}
                                                errorMessage={"This is a mandatory field"}
                                            />
                                        </Flex>

                                        <Flex start centerHorizontally gap='8px' style={{ marginTop: 24 }}>
                                            <Text right caption weight='400' width="60px">CC:</Text>

                                            <LabeledInput
                                                inputRef={this.subjectRef}
                                                nomargin
                                                small
                                                id="ccEmail"
                                                key="ccEmail"
                                                placeholder=""
                                                onChange={(event) => this.setState({ ccEmail: event.target.value })}
                                                value={ccEmail}
                                                error={errorField === "ccEmail"}
                                                errorMessage={"This is a mandatory field"}
                                            />
                                        </Flex>

                                        <Flex start centerHorizontally gap='8px' style={{ marginTop: 24 }}>
                                            <Text right caption weight='400' width="60px">Subject:</Text>

                                            <LabeledInput
                                                inputRef={this.subjectRef}
                                                nomargin
                                                small
                                                id="subject"
                                                key="subject"
                                                placeholder="Enter subject"
                                                onChange={(event) => this.setState({ subject: event.target.value })}
                                                value={subject}
                                                error={errorField === "subject"}
                                                errorMessage={"This is a mandatory field"}
                                            />
                                        </Flex>

                                        <Divider margin='24px 0' color='#F2F2F2' />

                                        <Flex fullWidth center style={{}}>
                                            <Flex style={{ width: 600 }} center>
                                                {mainHTML && renderHTML(mainHTML)}
                                            </Flex>
                                        </Flex>

                                        <Divider margin='24px 0' color='#F2F2F2' />

                                        {mainHTML && <Flex start centerHorizontally gap="24px" style={{ padding: '24px 24px' }}>
                                            <Button solid text='Send' onClick={this.send} loading={loadingSendEmail} />

                                            <TextButton text="Edit billing link" underline weight='400' onClick={() => this.setState({ step: 'customize' })} />

                                            <TextButton text="Learn more" underline weight='400' color='#8181A0' onClick={() => this.setState({ showLearnMore: true })} />
                                        </Flex>}
                                    </FlexColumn>
                                </CardContainer>
                            </FlexColumn>
                        </FlexColumn>
                    default:
                        return '';
                }
            })()}

            <AlertModal
                visible={showSentModal}
                title={`Billing link sent`}
                description={<Flex start wrap center gap="4px">
                    <Text size='16px'>A payment setup link has been sent to</Text>
                    <Text size='16px' weight='600'>{customers[0]?.displayName}</Text>
                    {/* <Text weight='600'>(${customers[0]?.ToAddr}).</Text> */}
                    <Text size='16px' center>Your customer can access the link, provide their details and authorize you to charge them.</Text>
                </Flex>}
                buttonTitle='Okay'
                onConfirm={() => window.history.back()}
                descWidth="470px"
                checkmark
            />s

            <Modal
                visible={showLearnMore}
                footer={null}
                closable={true}
                width={608}
                destroyOnClose={true}
                bodyStyle={{ padding: 0 }}
                onCancel={() => this.setState({ showLearnMore: false })}
                closeIcon={<img width='24px' height='24px' src={ModalClose} />}
            >
                <FlexColumn start gap="24px" style={{ width: 608, height: "100%", padding: "48px 48px", background: "#F3FAFF", borderRadius: 8 }}>
                    <Text size="20px" weight="600">How it works</Text>

                    <Flex start gap='24px'>
                        <Image src={Link} />
                        <FlexColumn gap="4px">
                            <Text size="16px" weight="600">Create and share link</Text>
                            <Text>Create a billing link and share with your customer. Your link expires in 7 calendar days.</Text>
                        </FlexColumn>
                    </Flex>

                    <Flex start gap='24px'>
                        <Image src={Payment} />
                        <FlexColumn gap="4px">
                            <Text size="16px" weight="600">Capture payment details</Text>
                            <Text>Your customer accesses the link, provides their bank details and authorizes you to charge them.</Text>
                        </FlexColumn>
                    </Flex>

                    <Flex start gap='24px'>
                        <Image src={Verified} />
                        <FlexColumn gap="4px">
                            <Text size="16px" weight="600">Payment details verification</Text>
                            <Text>A $1 fee is collected as soon as customer authorization is complete. Fee transaction may take up to 2 business days to settle.</Text>
                        </FlexColumn>
                    </Flex>

                    {/* <Flex start gap='24px'>
                    <Image src={Dollar} />
                    <FlexColumn gap="4px">
                        <Text size="16px" weight="600">Interest payout</Text>
                        <Text>Interest is calculated as simple interest daily based on the day’s ending available balance. Monthly interest amount is paid on or before 10th calendar day of the following month.</Text>
                    </FlexColumn>
                </Flex> */}
                </FlexColumn>
            </Modal>
        </FlexColumn>
        )
    }
}

function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer,
        receivablesStore: state.receivablesAppReducer,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(SendPaymentNotification)))